module.exports = __webpack_public_path__ + "static/images/9108b969d9e042a316c4c01045d61b8d.webp";